function handleFormatRawDatepickerValue(rawValue) {
  //change DD/MM/YYYY to YYYY-MM-DD to be able to pass the value to "new Date()"
  let dateParts = rawValue.split("/");
  return dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
}

export default handleFormatRawDatepickerValue;
